var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"address-selector-view"},[_c('Breadcrumb',{attrs:{"items":_vm.breadCrumbs}}),_c('v-btn',{staticClass:"onboarding-back mb-3",attrs:{"color":"primary","text":"","link":"","to":{
      name: 'DeliveryServiceView'
    }}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("$arrowBack")]),_vm._v(" Torna alla scelta del servizio ")],1),_c('AddressSelector',{attrs:{"deliveryServiceId":_vm.deliveryServiceId,"isNotPopup":true},on:{"submit":_vm.goToTimeslotView}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }